import Vue from 'vue'
import TransitionExpand from '@components/TransitionExpand.vue'
import ClickMenu from '@components/ClickMenu.vue'
const el = document.querySelector('#masthead')
if (el != null) {
  var vm = new Vue({
    components: {
      TransitionExpand,
      ClickMenu
    },
    data: () => {
      return {
        windowWidth: window.innerWidth,
        showSearch: false,
        showMobileNav: false,
        showModal: false,
        FormieInstance: null
      }
    },
    delimiters: ['[[', ']]'],
    methods: {
      closeAll () {
        this.showSearch = false
        this.showMobileNav = false
      },
      toggleSearch () {
        this.showSearch = !this.showSearch
        this.showMobileNav = false
        if (this.showSearch === true) {
          this.$nextTick(() => {
            this.$refs.searchInput.focus()
          })
        }
      },
      toggleMobileNav () {
        this.showMobileNav = !this.showMobileNav
        this.showSearch = false
      },
      onResize () {
        this.windowWidth = window.innerWidth
      }
    },
    computed: {
      isDesktop () {
        return this.windowWidth > 1099
      }
    },
    watch: {
      showMobileNav: {
        handler (val) {
          if (this.showMobileNav) {
            document.documentElement.classList.add('is-clipped')
          } else {
            document.documentElement.classList.remove('is-clipped')
          }
        },
        deep: true
      },
      showModal: {
        handler: function (val) {
          if (this.showModal) {
            this.$nextTick(() => {
              window.Formie.initForms()
            })
            document.documentElement.classList.add('modal-open','is-clipped')
            } else {
            document.documentElement.classList.remove('modal-open','is-clipped')
          }
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize)
      })
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResize)
    }
  })
  vm.$mount(el)
}
